export default {
  "homepage": {
    "titolo": "Give yourself a chance!",
    "sottotitolo": "Meet new people",
    "accedi": "Log in",
    "registrati": "Sign up",
    "gia_registrato": "If you are already registered, log in:",
    "non_registrato": "If youâ€™re not registered yet, sign up now and start meeting new people!",
    "perche": "Why choose",
    "trova": "Find the right single for you",
    "sicurezza": "Safety is a priority for $servizio$",
    "aumenta_visibilita": "A complete profile helps you get noticed",
    "cerca_persona_adatta": "Meet new people",
    "desc_sicurezza": "The platform applies measures to provide a respectful and reliable environment for all members. Uploaded content is reviewed according to internal guidelines, and technical and organizational measures are in place to protect personal data.",
    "desc_visibilita": "Creating a profile with photos and details helps others understand who you are. More complete profiles tend to get more attention on the platform.",
    "desc_persona_adatta": "The platform allows you to browse profiles, start chats and build new connections online. Search filters and personalized suggestions help you find people aligned with your preferences.",
    "sezione_coppie": "Couples who met on $servizio$"
  },
  "navbar_mobileNew": {
    "cerca": "Search",
    "messaggi": "Messages",
    "profilo": "Profile",
    "vip": "VIP",
    "registrati": "Sign up",
    "incentive_menu": "Add message credits",
    "messaggi_restanti": "Credits",
    "rimanenti": "remaining",
    "logout": "Log out",
    "attiva_notifiche": "Telegram",
    "crediti": "Credits",
    "titolo_cerca": "SEARCH",
    "titolo_match": "MATCH",
    "titolo_messaggi": "MESSAGES",
    "titolo_notifiche": "NOTIFICATIONS",
    "titolo_avvisi": "ALERTS",
    "titolo_profilo": "PROFILE",
    "titolo_rateplan": "ADD CREDITS",
    "profilo_angel": "USER PROFILE",
    "diventa_premium": "GO PREMIUM"
  },
  "chat_content": {
    "disponibile": "online",
    "inserire_numero": "To share a number you must be a verified user like <strong>$angel$</strong>",
    "registrarti": "you need to choose a subscription plan",
    "scrivi_un_messaggio": "Write a message...",
    "rompi_il_ghiaccio": "Break the ice!",
    "prova_con": "Try one of these messages that people often use. Just pick up one and send it",
    "messaggio1": "Hi, Iâ€™d like to see your private photos",
    "messaggio2": "How are you? Feel like chatting for a bit?",
    "messaggio3": "I saw your profile and Iâ€™d like to get to know you better",
    "hook_blurred": "Read the message",
    "non_essere_timido": "$angel$ is online.<br>Send her a message!",
    "sta_scrivendo": "is typing..",
    "ha_visitato": "<i class=\"far fa-eye\"></i> visited your profile",
    "elimina_chat": "Delete chat",
    "sei_sicuro": "Are you sure?",
    "si": "Yes",
    "no": "No"
  },
  "profilo": {
    "cambia_foto": "Change photo",
    "username": "Username",
    "cambia": "change",
    "cognome": "Last name",
    "eta": "Age",
    "email": "Email",
    "sono": "Gender",
    "inserisci_numero": "Enter your phone number",
    "inserisci_username": "Enter your username",
    "inserisci_email": "Enter your email",
    "inserisci_citta": "Enter your city",
    "inserisci_eta": "Your age",
    "salva": "Save changes",
    "cerco": "Looking for",
    "citta": "City",
    "uomo": "Man",
    "donna": "Woman",
    "scegli": "Choose..",
    "solo_immagini": "Only images are allowed",
    "grandezza_file": "The photo must be smaller than 10Mb",
    "foto_non_conforme": "Photo rejected: violates platform guidelines",
      "foto_chat_non_conforme": "Message not sent: the photo violates platform policies",
    "mail_esistente": "This email is already in use",
    "seleziona_altra_mail": "Choose another email to update your profile correctly",
    "titolo_ok": "Changes saved successfully",
    "testo_ok": "Your profile has been updated correctly",
    "crediti_messaggi": "Credits",
    "aggiungi": "Add",
    "disiscrizione": "Unsubscribe",
    "header_disiscrizione": "Close your account",
    "titolo_disiscrizione": "Do you want to proceed with the unsubscribe?",
    "descrizione_disiscrizione": "You will lose all chances to chat with new women and enjoy new exciting experiences",
    "disiscrizione_ok": "Unsubscribe completed successfully",
    "disiscrizione_ko": "There was an error during unsubscribe, contact customer care",
    "descrizione": "Description",
    "cosa_cerco": "What are you looking for",
    "regione": "Choose your region",
    "utente_free": "You are a FREE user and you have $icebreacker$ icebreaker messages and $messaggi$ reply messages available. Become a PREMIUM user to get more messages",
    "diventa_premium": "Go PREMIUM now",
    "scegli_citta": "Choose your city",
    "impostazioni_profilo": "Profile settings",
    "disattiva_profilo": "Deactivate profile",
    "disattiva_profilo_ok": "Your profile has been deactivated and will no longer be visible to other users. To reactivate it, contact customer care",
    "torna_home": "Exit",
    "sei_sicuro_disattiva_profilo": "Are you sure you want to deactivate your profile?",
    "spiegazione-disattiva_profilo": "<div class=\"testo_popup_disattivazione\">By deactivating your profile you will no longer be able to:<ul><li>access the service</li><li>be visible to other users</li><li>use your credits</li></ul>. To reactivate your profile you will need to contact customer care - <span style=\"font-weight:bold\">Do you want to proceed?</span></div>",
    "si": "Yes",
    "no": "No",
    "ricevute_acquisti": "Purchase receipts",
    "gestione_notifiche": "Notification settings",
    "telegram": "Telegram",
    "notifiche_push": "Push notifications",
    "email_tracking": "Pixel tracking",
    "stato_profilo": "Profile status",
    "prossimo_addebito": "Next charge",
    "supporto": "Support"
  },
  "user": {
    "chat": "Send message",
    "mi_piace": "Like",
    "anni": "Age",
    "posizione": "Location",
    "capelli": "Hair",
    "altezza": "Height",
    "peso": "Weight",
    "descrizione": "Description",
    "cerca": "Looking for",
    "vicino_a_te": "Near you",
    "messaggi_rimanenti": "Messages remaining",
    "incentive": "Sign up to get more messages",
    "persona_interessata": "This person might be interested in you",
    "registrati_adesso": "Sign up now",
    "messaggi_illimitati": "so you can send unlimited messages and arrange a meeting",
    "blond": "Blonde",
    "brown": "Brown",
    "red": "Red",
    "darkblond": "Dark blonde",
    "black": "Black",
    "colored": "Dyed",
    "mi_piace_inviato": "Your Like has been sent â¤ï¸",
    "scrivile_in_privato": "Send a private message",
    "uomo": "Man",
    "donna": "Woman",
    "segnala_blocca": "Report or block",
    "utente_bloccato": "🚫 User blocked and reported, they will no longer be able to contact you"
  },
  "signup": {
    "registrazione": "Sign up",
    "immediata": "Instant",
    "incontri_segreti": "Private and discreet encounters...",
    "trova_ragazze": "Meet new women looking for a discreet escape for a few hours..",
    "scegli_una_password": "Choose a password",
    "continua": "CONTINUE"
  },
  "popupHook": {
    "utente_registrato": "is a VIP user!",
    "incentive_1": "To send more messages and talk with other available women, sign up for free.",
    "incentive_2": "To see her phone number, sign up now.",
    "altri_profili": "Show more profiles",
    "incentive_3": "Do you want to see all the other women available in your area?",
    "utenti_usano": "Most of our users prefer",
    "si_raccomanda": "We recommend signing up",
    "cambiar_profilo": "Premium users can change their profile",
    "per_cambiar_profilo": "To change your profile and add the contact of",
    "registrati_adesso": "Sign up now",
    "gia_account": "Already have an account?",
    "bentornato": "Welcome back! Enter your details to access the service",
    "registrati_home": "Start connecting and meet people near you!",
    "accedi_subito": "Log in now!",
    "continua": "CONTINUE",
    "blurred_title": "Message not visible",
    "blurred_body": "has chosen to chat only with verified users like her.",
    "blurred_incentive": "Do you want to read <strong>$angel$</strong>â€™s reply?",
    "espresso_desiderio": "has chosen to meet ONLY verified users like her",
    "vuoi_vedere": "Do you want to see her photos, details and message her right away?",
    "verifica_ora": "Verify your account now",
    "diventa_premium": "Go premium",
    "verifica_profilo": "Verify profile",
    "messaggio_non_mandato": "Message can't be sent",
    "attiva_pass": "Unlock your <strong>MESSAGES</strong> to send it IMMEDIATELY",
    "attiva_lettura": "Do you want to know if <strong>$angel$</strong> reads your messages?",
    "ti_piace": "Like",
    "attiva_generico": "Do you want to keep sending LIKEs?",
    "mi_piace_inviato": "Your Like has been sent â¤ï¸",
    "donne_regione": "VIP users can view profiles from other regions",
    "sottotitolo_regione": "To see all women online from other regions, we recommend going VIP",
    "messaggio_sospeso": "1 message is pending",
    "attiva_pass_senza_limiti": "Do you want to keep messaging <strong>$angel$</strong>?",
    "per_scoprire": "To find out more about <strong>$angel$</strong>, she wants you to verify your account now",
    "la_vuoi_conoscere": "DO YOU WANT TO MEET ",
    "imposta_regione": "Select a city where you want to find women for your next date",
    "quasi_terminato": "Youâ€™re almost done!",
    "inizio_divertimento": "Let the fun begin! ðŸ’‹",
    "inserisci_mail_e_pws": "Enter your email and choose a secure password",
    "ti_invieremo": "We will send you an email. Open it and click the link to verify <strong>your account</strong> and interact with other users",
    "se_non_trovi": "ðŸš¨ If you donâ€™t see the email, check your SPAM or JUNK folder. ðŸš¨",
    "non_lasciare_sospeso": "The message for <strong>$angel$</strong> can't be sent!",
    "altri_uomini": "<i>Other men online could message her now.</i>",
    "utente_disabilitato": "Your account is disabled. Contact customer care"
  },
  "popupNotifica": {
    "hai_ricevuto_messaggio": "You received a message",
    "da": "from",
    "rispondi": "Reply",
    "profilo": "Profile",
    "hai_ricevuto_like": "sent you a LIKE!",
    "risposta_a_like": "replied to your LIKE! Send her a message now",
    "ha_guardato_tuo_profilo": "just viewed your profile",
    "avvisami_risposta": "Let me know when she replies",
    "avvisami_novita": "Let me know about new activity",
    "visualizza": "View profile"
  },
  "popupInfo": {
    "anni": "Age"
  },
  "popupGenerico": {
    "chiudi": "Close",
    "cambia_carta": "Use a different card",
    "bentornato": "Welcome back, we missed you!",
    "regalo_messaggi": "Thatâ€™s why weâ€™ve given you some credits. ðŸ’° Start chatting with whoever you like!"
  },
  "popupFoto": {
    "carica_foto": "Upload a photo <br /> to complete your profile",
    "incentivo": "Users with a photo <br/>receive <strong>7 times more messages!</strong>",
    "lo_faro_dopo": "Iâ€™ll do it later"
  },
  "signupForm": {
    "caricando": "Loading...",
    "scegli_una_password": "Choose a password",
    "registrati_gratis": "Sign up for free now",
    "accedi": "Log in",
    "gia_registrato": "Already registered?",
    "iscriviti": "Not registered yet?",
    "password": "Password",
    "password_dimenticata": "Forgot password?",
    "indietro": "Back to login",
    "invia": "Submit",
    "introduci_mail_reset_password": "Enter your email to start the password reset process",
    "email_inviata": "A link has been sent to your email to reset your password.",
    "utente_inesistente": "The email address does not exist",
    "mail_password_errati": "Email or password is incorrect",
    "sono": "I am",
    "cerco": "Looking for",
    "citta": "City",
    "email": "Enter your email",
    "suggerimento_citta": "Type at least three characters and select from the list",
    "errore_citta": "Fill in the region field",
    "errore_email": "Fill in the email field",
    "errore_password": "Fill in the password field",
    "regione": "Choose your region",
    "eta": "Enter your age",
    "errore_sono": "Fill in the â€œI amâ€ field",
    "errore_cerco": "Fill in the â€œLooking forâ€ field",
    "errore_terms": "To continue you must accept the terms of service",
    "accetto_clausole": "I expressly accept the clauses listed in art.14 of the <a href=\"$terms$\">Terms and Conditions</a> of the service",
    "acconsento_trattamento": "I consent to the processing of my personal data for promotional purposes as described in the <a href=\"$privacy$\">Privacy Policy</a>",
    "acconsento_comunicazione": "I consent to the sharing of my personal data with third parties for their marketing purposes, as described in the <a href=\"$privacy$\">Privacy Policy</a>",
    "dichiaro_maggiorenne": "I confirm that I am over 18",
    "cliccando_accetti": "By clicking Sign up you confirm that you have read and accepted the <a href=\"$privacy$\">Privacy Policy</a> and the <a href=\"$terms$\">Terms and Conditions</a> of the service",
    "orientamenti_sessuali": "I give explicit consent to the processing of data that may reveal my sexual preferences and orientation, as described in the <a href=\"$privacy$\">Privacy Policy</a>"
  },
  "photoItem": {
    "bottone_chat": "Chat",
    "bottone_like": "Like",
    "bottone_profilo": "Profile",
    "registrati_gratis": "Sign up for free now",
    "anni": "age"
  },
  "create_list": {
    "hai_ricevuto_like": "You received a like",
    "hai_ricevuto_visita": "Visited your profile",
    "ha_rispost_like": "Replied to your like!",
    "non_letto": "UNREAD",
    "nessuna_notifica": "You havenâ€™t received any notifications yet",
    "nessun_messaggio": "You havenâ€™t received any messages yet. Add a profile photo and use the Match page to send some likes",
    "mi_piace": "Like",
    "elimina_chat": "Delete chat",
    "sei_sicuro": "Are you sure?",
    "si": "Yes",
    "no": "No"
  },
  "navbar_desktop": {
    "cerca": "Search",
    "messaggi": "Messages",
    "profilo": "Profile",
    "registrati": "Sign up",
    "vip": "VIP",
    "incentive_menu": "Sign up to get more messages",
    "messaggi_restanti": "Credits",
    "rimanenti": "remaining",
    "logout": "Log out",
    "attiva_notifiche": "Enable notifications",
    "notifiche": "Notifications",
    "match": "Match"
  },
  "creditCardForm": {
    "numero_carta": "Card number",
    "nome_intestatario": "Cardholder first name",
    "cognome_intestatario": "Cardholder last name",
    "scadenza": "Expiry date",
    "CVC": "CVC",
    "continua": "CONTINUE",
    "tasto_riprova": "TRY AGAIN",
    "carta": "Credit card",
    "nome": "First name",
    "cognome": "Last name",
    "disclaimer_fluxid0000": "By clicking continue you accept the <a href=\"$terms$\"> Terms and Conditions</a> and the <a href=\"$privacy$\"> Privacy Policy </a>",
    "disclaimer": "By clicking continue you accept the <a> Terms and Conditions</a> and the <a> Privacy Policy </a>",
    "pagamento_sicuro": "Secure payment",
    "descriptor": "We care about your privacy and respect your personal life. The charge on your credit card will appear as $descriptor$ on your statement",
    "errore": "Error",
    "qualcosa_storto": "Something went wrong",
    "cambia_carta": "Try a different card to continue chatting or choose another payment method",
    "cvv_errato": "The CVV/CVC is not correct. Please check it or use a different payment method to continue chatting.",
    "fondi_insufficenti": "It looks like your card has insufficient funds or has reached its limit. Please check or use a different payment method",
    "persa_rubata": "This card cannot be used. Try a different card or choose another payment method to continue chatting",
    "scaduta": "Your card has expired. Update your card or use a different payment method to continue chatting",
    "gia_processata": "This card has already been declined. Please try a different card.",
    "numero_carta_non_valido": "Check that your card details are correct to continue chatting",
    "riprova": "Additional verification required. In the next steps you will be redirected to your bank to confirm your identity. You may receive an SMS or a notification from your bank app.",
    "blacklisted": "Your card has been blocked",
    "generico": "Card declined. Try a different card to continue chatting or choose another payment method",
    "3ds": "Additional verification required",
    "verifica_fallita": "The verification requested by your bank to confirm your identity was not successful",
    "success": "Thank you, your payment was successful. Keep chatting and good luck with your next date",
    "consiglio_generico": "Try a different card to continue <span className=\"special_bold\">CHATTING</span>",
    "consiglio_insufficent_fund": "Your card cannot be used due to insufficient funds, please use a different card to continue chatting",
    "consiglio_3ds": "In the next steps you will be redirected to your bank to verify your identity. Confirm the notification from your bank",
    "disclaimer_verifica_eta": "By clicking CONTINUE, you accept our Terms of Use and Privacy Policy, and a â‚¬0.01 verification fee may be charged.",
    "descrizione_pending": "Your bank is taking longer than expected. You can keep browsing, your credits will be added once the transaction is approved",
    "titolo_cvv": "Check CVV/CVC",
    "titolo_fondi_insufficenti": "Insufficient funds?",
    "titolo_persa_rubata": "Card cannot be used",
    "titolo_generico": "Card declined",
    "titolo_pending": "Transaction in progress",
    "titolo_success": "Payment successful",
    "titolo_verifica_fallita": "Payment error",
    "titolo_riprova": "Additional verification required",
    "cambia_metodo_pagamento": "This payment method has been blocked due to too many failed attempts. Please try a different payment method.",
    "open": "We are waiting for your bank to confirm the payment. Credits will be added once approved. This usually takes a few minutes",
    "titolo_open": "Payment pending",
    "titolo_canceled": "Payment cancelled",
    "descrizione_canceled": "You cancelled the payment. Try again to continue chatting",
    "titolo_problemi_api": "Transaction failed",
    "descrizione_problemi_api": "There seems to be an issue with this payment method. Please try another one",
    "pagamento_in_corso": "Processing payment...",
    "attendi_un_minuto": "A payment is already in progress, please wait a minute before trying again.",
    "waiting": "We are waiting for confirmation from your bank. Please wait a moment",
    "titolo_waiting": "Just a moment",
    "titolo_pacchettone": "Congratulations!",
    "descrizione_pacchettone": "We want to reward your engagement<br>with a <strong>special surprise</strong> for you!",
    "prendine_un_altro": "Get another one at half price!",
    'disclaimer_opale': 'Free trial of the online seduction coaching service.<br> The 10-day trial allows you to talk with coaches every day, receive personalized advice and access exclusive articles. After the trial period, the service automatically renews at â‚¬19.90 every 14 days, until cancelled.'
  },
  "payment_page": {
    "pagamento_sicuro": "Secure payment",
    "dati_protetti": "Your card details are protected with SSL encryption",
    "non_paghi_nulla": "Note: You will not be charged to verify your account. Providing a valid card is the only way to confirm you are a real user like all verified users",
    "verifica_profilo": "Verify profile",
    "stai_acquistando": "You are purchasing",
    "procedura": "Age verification via credit card is FREE",
    "nessun_addebito": "<strong>â‚¬ 0.00 - No charge</strong><br>ADULTS ONLY!",
    "inserisci_e_verifica": "Enter your card details<br>and confirm you are over <strong>18</strong>",
    "nessun_abbonamento": "This is <strong>NOT</strong> a subscription.<br>You will <strong>NOT</strong> be charged again.",
    "scegli_metodo": "How would you like to proceed?",
    "attiva_pass": "Unlock your <strong>MESSAGES</strong> to send it IMMEDIATELY",
    "coda_discplaimer": "If you pay with PayPal, the service sale and transaction are handled directly by Coda Netherlands Holdings B.V.",
    "garanzia_di_rimborso": "Money-back guarantee",
    "garanzia_di_rimborso_text": "You are entitled to a full refund<br/> if you are not satisfied",
    "processando_pagamento": "We are processing your payment"
  },
  "pianiAbbonamento": {
    "disclaimer": "By choosing a credit package you accept the <a href=\"$terms$\"><u>Terms and Conditions</u></a> and the <a href=\"$privacy$\"><u>Billing Policy</u></a>",
    "disclaimer2": "If you selected the PROMO plan, after the 72-hour trial it will convert into a monthly subscription at â‚¬29.99 and will renew every month until cancelled. <a href=\"$terms$\"><u>Click here</u></a> for information on how to cancel your subscription",
    "disclaimer3": "By choosing a credit plan you accept the <a href=\"$terms$\"><u>Terms and Conditions</u></a> and the <a href=\"$privacy$\"><u>Billing Policy</u></a>",
    "disclaimer4": "I accept the <a href=\"$terms$\"><u>Terms and Conditions</u></a> and the <a href=\"$privacy$\"><u>Billing Policy</u></a>",
    "discplaimer5": "All plans renew automatically",
    "errore": "Error",
    "qualcosa_storto": "Something went wrong",
    "header_chatta_senza_limiti": "Your message to <strong>$angel$</strong> cannot be sent",
    "header_fine_like": "Do you want to send unlimited LIKEs?",
    "header_messaggio_offuscato": "Do you want to read <strong>$angel$</strong>â€™s message?",
    "header_paginazione": "Do you want to see all women online?",
    "header_cambio_regione": "Do you want to search for women in other regions?",
    "testo_verifica_eta": "To ensure the <strong> safety </strong> of our users, <strong> we need to verify that you </strong><br><strong> are over 18 </strong>",
    "testo_bottone_verifica_eta": "I AM 18+",
    "aggiungiamo_crediti": "We are adding your credits",
    "altri_uomini": "<i>Other men could message her</i>",
    "vuoi_continuare": "Activate your <strong>PASS</strong> to send it IMMEDIATELY",
    "redirigendo": "Redirecting to the payment page",
    "crediti": "Credits",
    "approfitta_ora": "Take advantage of <strong>this offer</strong><br />to keep enjoying the benefits.",
    "like_illimitati": "â–ª Unlimited likes<br />â–ª Chat with anyone you want"
  },
  "passwordReset": {
    "caricando": "Loading...",
    "procedura": "Enter your new password in the fields below",
    "password": "New password",
    "ripeti": "Repeat password",
    "invia": "Submit",
    "non_corrispondono": "The two passwords do not match",
    "passwordCambiata": "Password updated successfully. Go to the login page",
    "token_expired": "The password reset has already been completed. Please try again"
  },
  "errorHandler": {
    "email_esistente": "This email already exists. Try logging in",
    "utente_non_trovato": "Invalid username or password",
    "qualcosa_storto": "Something went wrong, please try again",
    "fingerprint": "It looks like you are already registered with this email: $email$, try logging in",
    "email_non_valida": "The email address appears to be incorrect. Check punctuation and spacing",
    "email_vietata": "This email cannot be used. Please use another one",
    "troppi_tentativi": "Too many signup attempts",
    "account_disabilitato": "Your account has been disabled. Contact customer care",
    "welcome_gia_inviata": "The welcome email has already been sent to this address <strong class=\"blink\">check your <blink>Spam</blink> or <blink>Junk</blink> folder</strong>."
  },
  "logo": {
    "url": "/img/logo_it.png"
  },
  "ok": {
    "congratulazioni": "Congratulations!",
    "utente_premium": "You are now a premium user",
    "bottone_chat": "Go to chats"
  },
  "ko": {
    "ops": "Oops!",
    "qualcosa_storto": "Something went wrong",
    "bottone_indietro": "Try again"
  },
  "searchFilters": {
    "titolo_popup": "Type and select the city where you want to see available women",
    "seleziona": "Select",
    "seleziona_regione": "Search filters"
  },
  "footer": {
    "faq": "FAQ",
    "termini": "Terms and Conditions",
    "privacy": "Privacy Policy",
    "cookie": "Cookie Policy",
    "contact_us": "Contact us"
  },
  "chats": {
    "nessun_messaggio": "You have no messages yet"
  },
  "contactUs": {
    "contattaci": "Contact us",
    "per_ricevere": "To receive direct support, contact us using the form on this page or through the following details",
    "caricando": "Loading...",
    "grazie": "Thank you, your message has been received"
  },
  "landingAutologin": {
    "titolone": "IMPORTANT",
    "testo": "<strong>$angel$</strong> is looking for you. Remember, she and other users on this site are looking for fun, not a relationship. Many are married and unhappy, others are single mothers. They all live in $regione$. If you meet one or more of them, please keep their identity private within this club. To view <strong>$angel$</strong>â€™s message and accept the club rules, click continue.",
    "pulsante": "Continue"
  },
  "landingAutosignup": {
    "titolone": "IMPORTANT",
    "testo": "Remember that you and the other members of this club are looking for fun, not a relationship. Many are married and unhappy, others are single mothers. They all live in your area. If you meet one or more of them, please keep their identity private within this club. By continuing you accept the club rules, choose your region and click continue.",
    "pulsante": "Continue"
  },
  "telegramPush": {
    "titolo": "Don't miss a single message",
    "titolo_nome": "$nome$ will reply.",
    "sottotitolo": "Where should we let you know?",
    "consigliato": "Recommended",
    "presto": "Soon",
    "push_titolo": "Phone notifications",
    "push_testo": "One tap, no app to install.",
    "push_attivo": "On. We'll notify you on your phone.",
    "push_ios": "First add the site to your Home Screen.",
    "telegram_testo": "Instant and discreet. Turn it off any time.",
    "telegram_attivo": "On. We'll notify you here.",
    "whatsapp_testo": "Messages arrive where you already chat.",
    "whatsapp_messaggio": "Hi! Please turn on notifications for $email$",
    "passo_1": "Tap Share at the bottom of Safari",
    "passo_2": "Choose \"Add to Home Screen\"",
    "passo_3": "Open the site from the icon and come back here",
    "push_negato": "You blocked notifications: turn them back on in your browser settings.",
    "push_non_supportato": "This browser doesn't support notifications. Open the site in Chrome or Safari, or choose Telegram.",
    "push_errore": "We couldn't turn them on. Please try again shortly.",
    "fatto": "Done. From now on we'll notify you here.",
    "torna_chat": "Back to the chat",
    "torna_chat_nome": "Back to the chat with $nome$"
  },
  "cookie": {
    "disclaimer": "<p>Este sitio utiliza cookies o otras herramientas tÃ©cncias y, previo consentimiento, tambiÃ©n cookies de perfil u otras herramientas de seguimiento, tambiÃ©n de terceros, para enviarte publicidad personalizada y ofrecerte servicios en lÃ­nea con tus preferencias, asÃ­ como la supervisiÃ³n del comportamiento de los visitantes. Si quieres saber mÃ¡s, consulta la PolÃ­tica de Cookies</p><p>Si cierras este banner pinchando en la Â«XÂ», seguirÃ¡s navegando por el sitio sin cookies ni otras herramientas de seguimiento que no sean las tÃ©cnicas.</p>",
    "button": "Accept all cookies",
    "rifiuta": "Reject all"
  },
  "doi_popup": {
    "complimenti": "Well done!",
    "attiva_account": "Activate your account",
    "conferma": "Confirm your address now",
    "indirizzo_inserito": "The address you entered:",
    "risulta_non_valido": "is <strong>NOT VALID</strong>",
    "titolo": "Your profile on $servizio$ has been created successfully",
    "descrizione": "We have sent an email to:",
    "indirizzo_indicato": "Your email:",
    "se_sbagliata": "If it's not correct, you can change it below:",
    "cambia_mail": "Change email address",
    "invia": "Change",
    "errore_stessa_mail": "You entered the same email used during registration. We have already sent a message to that address. Please also check your Spam folder",
    "importante": "Important",
    "messaggio_ok": "We have sent a message to the new email address.",
    "errore_su_cambio_email": "it was not possible to change the email address",
    "punto1": "<strong>Check</strong> your <strong class=\"blink\"><blink>\"Spam\"</blink> folder</strong> to make sure our email is not there",
    "punto2": "Our email may take up to 5 minutes to arrive.",
    "punto3": "Mark our message as <strong>\"NOT SPAM\"</strong> to make sure you receive all messages from women on $servizio$"
  },
  "find": {
    "donne_disponibili": "Women available in your area:"
  },
  "tooltip": {
    "titolo_attiva_notifiche": "ðŸ’Œ Enable notifications",
    "attiva_notifiche": "Donâ€™t miss the chance to meet women who message you or view your profile. Enable notifications now and increase your chances by 90%! ðŸ˜",
    "bottone_attiva_notifiche": "Enable now!"
  },
  "unsubscribe": {
    "titolo": "Unsubscribe from the newsletter",
    "sottotitolo": "Weâ€™re sorry to see you go. Click the button below to confirm your unsubscribe. If you change your mind, you can always subscribe again in the future!",
    "testo_bottone": "Unsubscribe",
    "testo_popup": "<strong>Unsubscribed successfully!</strong><br> You will be redirected to the homepage"
  },
  "match": {
    "manda_invito": "Send an invite",
    "anni": "age",
    "su_di_me": "About me"
  },
  "recensioni": {
    "cosa_dicono": "<strong>What users say</strong> online"
  }
}
